module.exports = __webpack_public_path__ + "static/media/afh-banner.47fa1281.jpg";